// extracted by mini-css-extract-plugin
module.exports = {"advice":"FormAdvice_advice_3qb0U"};